import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { throwError, zip } from 'rxjs';
import { RunTimeConfigService } from '@shared/services/run-time-config.service';
import { catchError, map, take } from 'rxjs/operators';
import { ApiService } from '@shared/services/api.service';
import ticketAPIConfig from 'src/app/modules/apps/new-ticketing-dashboard/new-ticketing-dashboard-api.config.json';
import { TicketsService } from '@shared/services/ticketing.service';
import { NewTicketsService } from '@shared/services/new-ticketing.service';
import { ToastService } from '@shared/modules/toast/services/toast.service';
import { AuthService } from '@shared/services/auth.service';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
// import { analyzeAndValidateNgModules } from '@angular/compiler';
import { ItemsList } from '@ng-select/ng-select/lib/items-list';

@Injectable({
  providedIn: 'root'
})
export class TicketingStatusResolver implements Resolve<any> {
  constructor(
    private runTimeConfigService: RunTimeConfigService,
    private apiService: ApiService,
    private ticketsService: TicketsService,
    private newticketService: NewTicketsService,
    private toastService: ToastService,
    private router: Router,
    private authService: AuthService
  ) {}

  resolve(route: ActivatedRouteSnapshot) {
    let UIStatusesIncidentTask: any;

    return new Promise((resolve, reject) => {
      const existingConstants = this.ticketsService.getAllStatusConstants();
      if (existingConstants) {
        resolve(existingConstants);
      }

      let allStatusCodes: any;
      const itsmCodes: any = [];
      let itsmStatusCodes: any = [];

      this.runTimeConfigService
        .getAppSpecificSettings('ticketing-new-settings.config.json')
        .subscribe((UIStatusCodes: any) => {
          this.apiService
            .get(ticketAPIConfig.canonicalCodes, {
              params: {
                field: 'state'
              }
            })
            .subscribe(
              (canonicalStatusCodes: any) => {
                console.log('canonicalStatusCodes', canonicalStatusCodes);
                if (UIStatusCodes && canonicalStatusCodes && canonicalStatusCodes.length > 0) {
                  UIStatusesIncidentTask = UIStatusCodes.constants.TICKET_STATUS.concat(
                    UIStatusCodes.constants.TASK_STATUS
                  );

                  for (const statusObject of canonicalStatusCodes) {
                    // match and update internal constants
                    const foundStaticMapMatch = UIStatusesIncidentTask.find(
                      (c: any) =>
                        c.ciap_code === statusObject.ciap_code &&
                        (!statusObject.type || (statusObject.type && c.type === statusObject.type))
                    );
                    if (foundStaticMapMatch) {
                      foundStaticMapMatch.itsm_value = statusObject.itsm_value;
                      foundStaticMapMatch.itsm_code = statusObject.itsm_code;
                      // console.log(statusObject, 'foundStaticMapMatch');
                    } else {
                      /*
                       * If UI constants settings does not have a state match with ITSM, the code for that won't work
                       * For example: UI has code written for CIAP state: 'In Progress' but if canonical data's itsm value does not have
                       * a match for it, UI code will be redundant.
                       * UI always maintains a list of CIAP states and the code is written for these states
                       * If a match for this state is not found in canonical data mapping, the below error is thrown
                       */
                      // this.toastService.showToast(
                      //   'Alert: No match found in UI constants mapping for state: ' + statusObject.itsm_value,
                      //   'toastWarning',
                      //   {
                      //     delay: 20000
                      //   }
                      // );
                      console.warn('No match found in UI constants mapping for ' + statusObject.itsm_value);
                      // foundStaticMapMatch.itsm_value = null;
                      // foundStaticMapMatch.itsm_code = null;
                    }
                    for (const uiConstants of UIStatusesIncidentTask) {
                      if (
                        uiConstants.ciap_code === statusObject.ciap_code &&
                        (!statusObject.type || (statusObject.type && uiConstants.type === statusObject.type))
                      ) {
                        uiConstants.itsm_value = statusObject.itsm_value;
                        uiConstants.itsm_code = statusObject.itsm_code;
                      }
                    }
                  }

                  this.ticketsService
                    .getDynamicStatusAsPerClient('incident')
                    .subscribe((itsmStatusCodesIncdent: any) => {
                      this.ticketsService.getDynamicStatusAsPerClient('task').subscribe((itsmStatusCodesTask: any) => {
                        itsmStatusCodes = itsmStatusCodesIncdent.elements.concat(itsmStatusCodesTask.elements);

                        let itsmStatusCodesItem: any;
                        for (const code of itsmStatusCodes) {
                          itsmStatusCodesItem = {
                            ciap_value: code.label,
                            ciap_code: code.value,
                            type: code.type,
                            itsm_code: code.value,
                            itsm_value: code.label
                          };
                          itsmCodes.push(itsmStatusCodesItem);
                        }

                        // Getting Unique values from constants and getchoice api
                        console.log(' constants from UI ', UIStatusesIncidentTask);
                        console.log(' all itsm code ', itsmCodes);
                        // Added to pass itsm value for all open instead of hard coded value : start
                        const tktStatusCanonicalMapped = JSON.stringify(UIStatusesIncidentTask);
                        sessionStorage.setItem('tktStatusCanonicalMapped', tktStatusCanonicalMapped);
                        // Added to pass itsm value for all open instead of hard coded value : end

                        // remove matched const value from newCodes
                        for (let i = 0, len = UIStatusesIncidentTask.length; i < len; i++) {
                          for (let j = 0, len2 = itsmCodes.length; j < len2; j++) {
                            if (
                              UIStatusesIncidentTask[i].itsm_code === itsmCodes[j].itsm_code &&
                              UIStatusesIncidentTask[i].type === itsmCodes[j].type
                            ) {
                              itsmCodes.splice(j, 1);
                              len2 = itsmCodes.length;
                            }
                          }
                        }
                        console.log('remove constants in itsm code', itsmCodes);
                        //  append
                        allStatusCodes = UIStatusesIncidentTask.concat(itsmCodes);
                        console.log(' allStatusCodes ', allStatusCodes);

                        this.ticketsService.setStatusConstants(allStatusCodes);
                        this.newticketService.setStatusConstants(allStatusCodes);
                        // old setSTatusConstants call
                        //  this.ticketsService.setStatusConstants(UIStatusesIncidentTask);
                        resolve(UIStatusCodes);
                      });
                    });
                } else {
                  this.redirectToErrorPage();
                  reject([]);
                }
              },
              () => {
                if (!this.authService.hasAPIMTokenExpired) {
                  this.redirectToErrorPage();
                  reject([]);
                }
              }
            );
          // });
        });
    });
  }

  redirectToErrorPage() {
    const navigationExtras = {
      state: {
        canonicalStatusError: true
      }
    };
    // show error - canonical status not available
    this.router.navigate(['error'], navigationExtras).then(r => {});
  }
}
